import { Route, Navigate, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { AutoSignin } from './AutoSignin';
import { PrivateRoute } from './PrivateRoute';

import { App } from '../App';
import { ErrorBoundary } from '../design-system';
import {
  ErrorPage,
  ConstructionPage,
  SignIn,
  ForgotPassword,
  CreateNewPassword,
  MarketplaceClientYard,
  Dashboard,
  Overview,
  Containers,
  ContainersAdd,
  ContainersOut,
  ContainersView,
  GateIns,
  GateInsView,
  GateInsAdd,
  GateOuts,
  GateOutsView,
  GateOutsAdd,
  RepairsGroup,
  RepairsView,
  Inventory,
  InventoryAdd,
  InventoryView,
  StoragePricings,
  StoragePricingsAdd,
  StoragePricingsView,
  Reports,
  InvoicesByClientYard,
  Invoices,
  InvoicesView,
  UserVisits,
  UserVisitsView,
  Marketplace,
  ManageSales,
  Offers,
  SaleStats,
  SalesFees,
  SalesFeesAdd,
  SalesFeesView,
  YardCompanies,
  YardCompaniesAdd,
  YardCompaniesView,
  Yards,
  YardsView,
  YardsAdd,
  Clients,
  ClientsAdd,
  ClientsView,
  Employees,
  EmployeesAdd,
  Account,
  ThreeDPlaces,
} from '../pages';
import { MESSAGES } from '../const';
import { getDefaultRouter } from '../utils';

const originalRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        element={
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        }
        errorElement={
          <ErrorPage
            heading={MESSAGES.ERROR_BOUNDARY.HEADING}
            detail={MESSAGES.ERROR_BOUNDARY.DETAIL}
            navigateTo={-1}
          />
        }
      >
        <Route element={<AutoSignin />}>
          <Route index path={'signin'} element={<SignIn />} />
          <Route path={'forgotpassword'} element={<ForgotPassword />} />
          <Route path={'createnewpassword'} element={<CreateNewPassword />} />
          <Route path={'marketplace/:code'} element={<MarketplaceClientYard />} />
          <Route path={'marketplace/yards/:code'} element={<MarketplaceClientYard />} />
          <Route path={'dashboard'} element={<PrivateRoute Component={Dashboard} />}>
            <Route path={'overview'} element={<Overview />} />
            <Route path={'containers'} element={<Containers />} />
            <Route path={'containers/add'} element={<ContainersAdd />} />
            <Route path={'containers/out'} element={<ContainersOut />} />
            <Route path={'containers/:id'} element={<ContainersView />} />
            <Route path={'gateins'} element={<GateIns />} />
            <Route path={'gateins/:id'} element={<GateInsView />} />
            <Route path={'gateins/add'} element={<GateInsAdd />} />
            <Route path={'gateouts'} element={<GateOuts />} />
            <Route path={'gateouts/:id'} element={<GateOutsView />} />
            <Route path={'gateouts/add'} element={<GateOutsAdd />} />
            <Route path={'repairs'} element={<RepairsGroup />} />
            <Route path={'repairs/:id'} element={<RepairsView />} />
            <Route path={'inventory'} element={<Inventory />} />
            <Route path={'3d-places'} element={<ThreeDPlaces />} />
            <Route path={'inventory/add'} element={<InventoryAdd />} />
            <Route path={'inventory/:id'} element={<InventoryView />} />
            <Route path={'storage-pricing'} element={<StoragePricings />} />
            <Route path={'storage-pricing/add/:id'} element={<StoragePricingsAdd />} />
            <Route path={'storage-pricing/view/:id'} element={<StoragePricingsView />} />
            <Route path={'reports'} element={<Reports />} />
            <Route path={'invoices'} element={<InvoicesByClientYard />} />
            <Route path={'invoices/:clientYardId'} element={<Invoices />} />
            <Route path={'invoices/view/:id'} element={<InvoicesView />} />
            <Route path={'user-visits'} element={<UserVisits />} />
            <Route path={'user-visits/:id'} element={<UserVisitsView />} />
            <Route path={'marketplace'} element={<Marketplace />} />
            <Route path={'managesales'} element={<ManageSales />} />
            <Route path={'cart'} element={<Offers />} />
            <Route path={'sale-stats'} element={<SaleStats />} />
            <Route path={'sales-fees'} element={<SalesFees />} />
            <Route path={'sales-fees/add/:id'} element={<SalesFeesAdd />} />
            <Route path={'sales-fees/view/:id'} element={<SalesFeesView />} />
            <Route path={'yardcompanies'} element={<YardCompanies />} />
            <Route path={'yardcompanies/add'} element={<YardCompaniesAdd />} />
            <Route path={'yardcompanies/:id'} element={<YardCompaniesView />} />
            <Route path={'yards'} element={<Yards />} />
            <Route path={'yards/add'} element={<YardsAdd />} />
            <Route path={'yards/:id'} element={<YardsView />} />
            <Route path={'clients'} element={<Clients />} />
            <Route path={'clients/add'} element={<ClientsAdd />} />
            <Route path={'clients/:id'} element={<ClientsView />} />
            <Route path={'employees'} element={<Employees />} />
            <Route path={'employees/add'} element={<EmployeesAdd />} />
            <Route path={'account'} element={<Account />} />
            <Route index path={'*'} element={<Navigate to={getDefaultRouter(true)} replace />} />
          </Route>
        </Route>
      </Route>
      <Route path={'*'} element={<Navigate to={'/signin'} replace />} />
    </>,
  ),
);

const constructionRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route index element={<ConstructionPage />} />
      <Route path={'*'} element={<Navigate to={'/'} replace />} />
    </>,
  ),
);

export const router =
  process.env.REACT_APP_IS_CONSTRUCTION === 'true' ? constructionRouter : originalRouter;
